import { Flex, defaultFlexTag } from "../Flex/Flex";

/**
 * @typedef {import('../Flex/Flex').FlexProps} FlexProps
 * @typedef {Omit<FlexProps, 'direction'>} HStackProps
 */

/**
 * @param {HStackProps & { as?: React.ElementType, children?: React.ReactNode }} props
 */
export const HStack = (props) => {
    const { as, ...otherProps } = props;
    const tag = as ?? defaultFlexTag;

    return <Flex direction="row" as={tag} {...otherProps} />;
};
